import animateOnScroll from "./animateOnScroll"
import Rellax from 'rellax';
import Parallax from 'parallax-js';
import Plyr from 'plyr';
//animate elements
/*---------------
Notes
-----------------
Offset:
- .5 means half of the element is visible before triggering
- 1 means 100% of the element should be visible
- 0 would be if any part of the element is visible 
CSS animations:
- make sure that the transformX/Y is not too large otherwise it will take forever to animate in
*/
animateOnScroll([
    { selector: ".gradient-box, .quote-text, .gfield, .hero-item-entrance, .gradient-box .gradient", offset: 0, multiple: true }
]);

const rellax = new Rellax('.scrollax');

const scene = document.querySelector('.parallax-container');
const parallax = new Parallax(scene, {
    scalarX: 5,
    scalarY: 5,
});


window.addEventListener('DOMContentLoaded', () => {
    const players = Array.from(document.querySelectorAll('.js-player')).map((p) => new Plyr(p, {
        clickToPlay: true,
        poster: p.dataset.plyrPoster,
        controls: ['play-large'],
        youtube: {
            noCookie: false
        },
        fullscreen: {
            enabled: true,
            fallback: true,
            iosNative: true
        }
    }));
    players.forEach((player) => {
        player.on('ended', function () {
            player.stop();
        });
    });
});